document.addEventListener('DOMContentLoaded', () => {
  const bundlePageTitle = document.querySelector('.voo-bundle-page-title');
  const selectOptions = [];

  if(!bundlePageTitle) return;

  vooBundleWaitForEl('#product-variant-list').then(productVariantList => {
    productVariantList.querySelectorAll('option').forEach(option => {
      selectOptions.push(option.value);
    });

    const optionsHolder = document.createElement('div');
    optionsHolder.classList.add('voo-option-badge-holder');
    selectOptions.forEach((option, index) => {
      option = option.replace('discount', 'OFF').replace('(', '<span>').replace(')', '</span>');
      optionsHolder.innerHTML += `
        <div data-index='${index}' class="voo-option-badge ${productVariantList.selectedIndex === index ? 'selected' : ''}">
          ${option}
        </div>
      `;
    })

    const textEl = document.createElement('p');
    textEl.classList.add('voo-option-badge-text')
    textEl.innerText = 'The more you bundle, the more you save!';
    bundlePageTitle.after(optionsHolder)
    bundlePageTitle.after(textEl)

    productVariantList.addEventListener('change', () => {
      console.log
      optionsHolder.querySelectorAll('.voo-option-badge').forEach(option => {
        option.classList.remove('selected');
        if(Number(option.dataset.index) === Number(productVariantList.selectedIndex)){
          option.classList.add('selected');
        }
      })
    })
  })
})

function vooBundleWaitForEl(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}